export default "__VITE_ASSET__kmuprmXI__"